import React from 'react'

export default function Failure() {
  return (
    <div>
      Failed
    </div>
  )
}
